/*
 * @Author: taoyuan taoyuan@originqc.com
 * @Date: 2022-12-14 09:59:19
 * @LastEditors: taoyuan taoyuan@originqc.com
 * @LastEditTime: 2023-05-15 17:02:49
 * @FilePath: \qcloud-web-pc-4.0\src\views\home\lang\cn.js
 * @Description: 首页中文
 */
const home = {
  for_teacher: '面向教师',
  for_teacher_desc:
    ' 使用本源量子提供的课程和资源推进学生在量子计算领域的学<br />习，为学生创造学习、参与和构建量子计算未来的机会。',
  contactUs: '联系我们',
  course_title: '高校量子计算课程体系',
  course_desc:
    '助力高校开设量子计算专业课程，官方研发课程体系，提炼企业一线实际工作场景，理论+实践，快速理解课程知识点，前沿实用项目。',
  hardware: '量子计算硬件资源',
  hardware_desc:
    '注册本源量子云并访问本源提供的真实量子计算机。通过本源提供的量子计算和经典计算资源来实时学习、构建、实验量子应用程序。',
  software: '教育软件与工具',
  software_desc: '助力高校量子计算人才培养，提供端到端软硬一体应用。',
  tr_platform: '教研一体化平台 ',
  tr_platform_desc:
    '面向教育机构使用的量子教学软件，帮助学校搭建自己的量子计算教学体系。 ',
  learn_machine: '全物理体系量子学习机',
  learn_machine_desc:
    '一站式系统环境，提供量子计算及量子算法的学习、培训、开发、实验和应用。',
  more_next: '进一步了解',
  OriginqName: '本源溯知',
  for_college: '高校专属',
  free: '免费',
  resources: '资源',
  learn_quantum_computer: '量子计算机',
  learn_qubit_structure: '量子比特构造',
  learn_quantum_comput_demon: '量子计算演示',
  learn_chip_packaging: '芯片封装',
  learn_calculate_title1: '全物理体系量子学习机',
  subject_cooperation: '课题合作',
  learn_calculate_desc1:
    '本源量子计算全物理体系学习机是一个专为量子计算行业学习和从业人员设计的完整的仿真环境，它致力于量子算法及量子软件的学习、培训、开发、实验和应用。',
  'Solu-subject-1': '“科创融教”',
  'Solu-subject-11': '“科创融教”省部级纵向课题',
  'Solu-subject-12':
    '“科创融教”项目是由教育部行指委立项的一批教育改革创新课题，旨在研究解决“十四五规划”建设中教育的重点、难点问题。项目一年开展一次，每年10月份申报新一轮课题项目。<br />2021年，本源量子计算科技（合肥）股份有限公司获教育部行指委授权，为“产教融合研究”、“教学改革与创新创业教育研究”、“信息技术在教学中的应用”三大研究领域的六个研究方向提供技术支持，助力高校在相关领域进行深入研究。<br />首届“科创融教”省部级纵向课题已有50余所高校相继咨询、申报本源量子授权课题。今后，本源将继续本着“携手共进”原则，联合中国科学技术大学量子计算知名专家及本源量子资深行业应用研究员，为各申报院校提供一站式申报服务。',
  'Solu-subject-2': '产学合作协同育人',
  'Solu-subject-21': '“产学合作协同育人”',
  'Solu-subject-22':
    '教育部产学合作协同育人项目，是国家为了本科人才培养质量，深化产教融合、校企合作，教育部高等教育司组织有关企业支持高校共同开展产学合作协同育人的项目。<br />《教育部高等教育司2021年工作要点》指出，将深入推进新工科、新医科、新农科、新文科建设，促进“四新”交叉融合，提升国家硬实力、全民健康力、生态成长力和文化影响力。产学合作协同育人项目纳入新一轮普通高等学校本科教育教学审核评估指标体系。<br />本源量子将积极参与教育部高等教育司产学合作协同育人项目，携手各高校在新工科建设方面创新实践，助力高校推进学科建设发展。',
  'Solu-subject-3': '“北创助教”',
  'Solu-subject-31': '“北创助教”',
  'Solu-subject-32':
    '“北创助教项目(二期)”面向高校的量子计算、人工智能、轨道交通、智慧财务、智能建筑、社会科学、国际化人才培养在教育领域的应用而设立，以科技变革促进教育变革，创新人才培养机制，推动社会发展为目标。<br />2021年，本源量子计算科技（合肥）股份有限公司获北京创新研究所授权，为“量子计算教学内容和课程体系改革”、“量子计算应用研究及条件建设项目”两大课题方向提供技术支持，助力高校在相关领域进行深入研究。',
  competition_resources: '赛级资源',
  competition_resources_desc: '提供量子计算编程大赛赛级课程、练习内容。',
  discipline_construction: '学科建设资源',
  discipline_construction_desc:
    '提供量子计算师资培训、教学讲义、课件及实训资源。',
  open_learn: '开放学习资源',
  open_learn_desc: '提供QPanda量子计算编程框架及教材、科普读物资源。',

  platform_title: '量子计算云服务平台',
  platform_serve: '让量子计算真正为人类服务',
  platform_text:
    ' 本源量子云提供真实量子计算、量子计算模拟器和超-量混合计算后端接入，<br />为开发者提供基础软件与开发工具，为生物化学、金融科技、大数据、机器学习<br />等先进企业提供行业应用服务。',
  gonow: '立即体验',
  support: '在这里，我们为你提供支持',
  solution: '量子计算+行业解决方案',
  trip: 'Quantum on OriginQ，Journey Together',
  app_serve: '量子应用服务',
  ChemiQ: 'ChemiQ',
  portfolio_optimization: '投资组合优化',
  option_calculator: '期权计算器',
  var_cal: 'quantum VaR value calculation',
  pricing: '量子期权定价',
  image_recognition: '图像识别',
  QCFD: 'QCFD',
  more: '更多',
  cal_serve: '量子计算服务',
  real_cal: '真实量子计算服务',
  sim_cal: '模拟量子计算服务',
  hybrid: '量-超混合计算服务',
  community: '量子教育与社区服务',
  education: '溯知教育',
  contest: '比赛',
  comm: '社区',
  soft_serve: '量子软件服务',
  pilot: '本源司南',
  QPanda: 'QPanda',
  QRunes: 'QRunes',
  VQNet: 'VQNet',
  gui: 'GUI编程',
  Qurator: 'Qurator',
  Starter: '初次接触',
  starter_desc:
    '您可以了解量子计算的基本概念，并通过量子计算教程和GUI工具，尝试设计您的第一个量子程序吧！',
  Student: '学生',
  student_desc:
    '借助开源的软件工具和操作教程，每天只需几分钟即可获得量子计算的实用技能。',
  Developer: '开发人员',
  developer_desc:
    '您可以借助开源的软件工具，在个人PC上构建量子虚拟研究环境，或者通过量子云平台使用量子硬件进行研究。',
  Educator: '教育工作者',
  educator_desc:
    '使用本源量子提供的课程和资源推进学生在量子计算领域的学习，为学生创造学习、参与和构建量子计算未来的机会。',
  Company: '企业',
  company_desc:
    '以市场导向和产业需求为指引，推进量子计算在人工智能、大数据、金融、生物医药等各类场景的应用开发，加速量子计算实际应用进程。',
  Industrial_Alliance: '产业联盟',
  industrial_Alliance_desc:
    '携手合作伙伴共同致力于量子计算开发，探索量子计算应用落地，实现利益共享、合作共赢，合力推进量子计算产业发展。',
  biochemistry: '生物医药',
  biochemistry_desc: ' 量子计算赋能并加速国内外生物化学的研发进程。',
  finance: '金融科技',
  finance_desc:
    '本源量子围绕金融领域应用场景，推动量子生态的构建及其与金融产业的协同发展。',
  educate: '量子教育',
  educate_desc:
    '结合量子计算教育发展现状，依托本源量子全栈式教育产品，为您提供全场景解决方案。',
  bigData: '大数据',
  bigData_desc:
    '量子计算由于其并行数据处理的特性，以及量子态庞大的信息存储空间，使其天然适合大数据处理领域。',
  ai: '人工智能',
  ai_desc:
    '量子计算机能够比传统计算机更有效地分析数据以提供反馈，因而缩短人工智能机器的学习曲线。',
  learn_lab_detail4: '敬请期待',
  serviesTitle: '计算服务',
	serviesText: '用户可运行算法或进行实验任务，通过OriginQ Cloud接入的本源量子悟空系列超导量子计算机和虚拟计算服务。',
  serviesTitleOne: '真实量子计算服务',
	systemStatus: '系统状态',
	lineTime: '上线时间',
	calibrateTime: '上次校准时间',
	quantumBit: '量子比特',
	simulateServies: '虚拟计算服务',
	simulateType: '虚拟机类型',
	bitName: '比特超导量子计算机',
	freeText: '免费',
	ttText1:'队列任务数',
  ttText2:'最新校准时间',
  ttText3:'最新校准比特',
  ttText4:'最新校准比特对',
  ttText5:'量子比特',
	block1_text34:'维护中',
	chip_record:'芯片校准记录',
	chip_name:'服务名称',
	chip_school_time:'校准时间',
	chip_school_bit:'校准比特',
	chip_school_pair:'校准比特对',
};
export default home;
